import store from '@store'

export default [
    {
        path: '/login',
        name: 'login',
        component: () => import('@views/old/Login.vue'),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters['loggedIn']) {
                    // Redirect to the home page instead
                    next({name: 'home'})
                } else {
                    // Continue to the login page
                    next()
                }
            },
        },
    },
    {
        path: '/pwdreset/:token',
        name: 'pwdreset',
        component: () => import('@views/page/general/pwdreset/pwdresetPage.vue'),
    },
    {
        path: '/',
        component: () => import('@layouts/Main.vue'),
        meta: {
            authRequired: true,
        },
        children: [
            {
                path: '',
                name: 'home',
                component: () => import('@views/old/Home.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'home',
                },
            },
            
            // ADMIN
            
            {
                path: 'admin/actualitecategorylist',
                name: 'actualitecategorylist',
                component: () => import('@views/page/admin/actualitecategorylist/actualitecategorylistPage.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'admin',
                },
            },
            {
                path: 'admin/actualitelist',
                name: 'actualitelist',
                component: () => import('@views/page/admin/actualitelist/actualitelistPage.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'admin',
                },
            },
            {
                path: 'admin/agentlist',
                name: 'agentlist',
                component: () => import('@views/page/admin/agentlist/agentlistPage.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'admin',
                },
            },
            {
                path: 'admin/circuitlist',
                name: 'circuitlist',
                component: () => import('@views/page/admin/circuitlist/circuitlistPage.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'admin',
                },
            },
            {
                path: 'admin/level1list',
                name: 'level1list',
                component: () => import('@views/page/admin/level1list/level1listPage.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'admin',
                },
            },
            {
                path: 'admin/level2list',
                name: 'level2list',
                component: () => import('@views/page/admin/level2list/level2listPage.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'admin',
                },
            },
            {
                path: 'admin/level3list',
                name: 'level3list',
                component: () => import('@views/page/admin/level3list/level3listPage.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'admin',
                },
            },
            {
                path: 'admin/usergrouplist',
                name: 'usergrouplist',
                component: () => import('@views/page/admin/usergrouplist/usergrouplistPage.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'admin',
                },
            },
            {
                path: 'admin/userdetail/:id',
                name: 'userdetail',
                component: () => import('@views/page/admin/userdetail/userdetailPage.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'admin',
                    menuSelected: 'userlist',
                },
            },
            {
                path: 'admin/userlist',
                name: 'userlist',
                component: () => import('@views/page/admin/userlist/userlistPage.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'admin',
                },
            },
            
            // EPI
            
            {
                path: 'epi/epibonretraitcreate',
                name: 'epibonretraitcreate',
                component: () => import('@views/page/epi/epibonretraitcreate/epibonretraitcreatePage.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'epi',
                    menuSelected: 'epibonretraitlist',
                },
            },
            {
                path: 'epi/epibonretraitdetail/:id',
                name: 'epibonretraitdetail',
                component: () => import('@views/page/epi/epibonretraitdetail/epibonretraitdetailPage.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'epi',
                    menuSelected: 'epibonretraitlist',
                },
            },
            {
                path: 'epi/epibonretraitdispatch/:id',
                name: 'epibonretraitdispatch',
                component: () => import('@views/page/epi/epibonretraitdispatch/epibonretraitdispatchPage.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'epi',
                    menuSelected: 'epibonretraitlist',
                },
            },
            {
                path: 'epi/epibonretraitlist',
                name: 'epibonretraitlist',
                component: () => import('@views/page/epi/epibonretraitlist/epibonretraitlistPage.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'epi',
                },
            },
            {
                path: 'epi/epicommandecreate',
                name: 'epicommandecreate',
                component: () => import('@views/page/epi/epicommandecreate/epicommandecreatePage.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'epi',
                    menuSelected: 'epicommandelist',
                },
            },
            {
                path: 'epi/epicommandedetail/:id',
                name: 'epicommandedetail',
                component: () => import('@views/page/epi/epicommandedetail/epicommandedetailPage.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'epi',
                    menuSelected: 'epicommandelist',
                },
            },
            {
                path: 'epi/epicommandelist',
                name: 'epicommandelist',
                component: () => import('@views/page/epi/epicommandelist/epicommandelistPage.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'epi',
                },
            },
            {
                path: 'epi/epicommandeupdate/:id',
                name: 'epicommandeupdate',
                component: () => import('@views/page/epi/epicommandeupdate/epicommandeupdatePage.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'epi',
                    menuSelected: 'epicommandelist',
                },
            },
            {
                path: 'epi/epidemandecreate',
                name: 'epidemandecreate',
                component: () => import('@views/page/epi/epidemandecreate/epidemandecreatePage.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'epi',
                    menuSelected: 'epidemandelist',
                },
            },
            {
                path: 'epi/epidemandedetail/:id',
                name: 'epidemandedetail',
                component: () => import('@views/page/epi/epidemandedetail/epidemandedetailPage.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'epi',
                    menuSelected: 'epidemandelist',
                },
            },
            {
                path: 'epi/epidemandelist',
                name: 'epidemandelist',
                component: () => import('@views/page/epi/epidemandelist/epidemandelistPage.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'epi',
                },
            },
            {
                path: 'epi/epidemandesynthese',
                name: 'epidemandesynthese',
                component: () => import('@views/page/epi/epidemandesynthese/epidemandesynthesePage.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'epi',
                },
            },
            {
                path: 'epi/epireapprovisionnementdemandelist',
                name: 'epireapprovisionnementdemandelist',
                component: () => import('@views/page/epi/epireapprovisionnementdemandelist/epireapprovisionnementdemandelistPage.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'epi',
                },
            },
            {
                path: 'epi/epireapprovisionnementdemandecreate',
                name: 'epireapprovisionnementdemandecreate',
                component: () => import('@views/page/epi/epireapprovisionnementdemandecreate/epireapprovisionnementdemandecreatePage.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'epi',
                    menuSelected: 'epireapprovisionnementdemandelist',
                },
            },
            {
                path: 'epi/epireapprovisionnementretourcreate',
                name: 'epireapprovisionnementretourcreate',
                component: () => import('@views/page/epi/epireapprovisionnementretourcreate/epireapprovisionnementretourcreatePage.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'epi',
                    menuSelected: 'epireapprovisionnementretourlist',
                },
            },
            {
                path: 'epi/epireapprovisionnementretourlist',
                name: 'epireapprovisionnementretourlist',
                component: () => import('@views/page/epi/epireapprovisionnementretourlist/epireapprovisionnementretourlistPage.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'epi',
                },
            },
            {
                path: 'epi/epireapprovisionnementretourdetail/:id',
                name: 'epireapprovisionnementretourdetail',
                component: () => import('@views/page/epi/epireapprovisionnementretourdetail/epireapprovisionnementretourdetailPage.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'epi',
                    menuSelected: 'epireapprovisionnementretourlist',
                },
            },
            {
                path: 'epi/epibonreapprovisionnementcreate',
                name: 'epibonreapprovisionnementcreate',
                component: () => import('@views/page/epi/epibonreapprovisionnementcreate/epibonreapprovisionnementcreatePage.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'epi',
                    menuSelected: 'epibonreapprovisionnementlist',
                },
            },
            {
                path: 'epi/epibonreapprovisionnementdetail/:id',
                name: 'epibonreapprovisionnementdetail',
                component: () => import('@views/page/epi/epibonreapprovisionnementdetail/epibonreapprovisionnementdetailPage.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'epi',
                    menuSelected: 'epibonreapprovisionnementlist',
                },
            },
            {
                path: 'epi/epibonreapprovisionnementlist',
                name: 'epibonreapprovisionnementlist',
                component: () => import('@views/page/epi/epibonreapprovisionnementlist/epibonreapprovisionnementlistPage.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'epi',
                },
            },
            {
                path: 'epi/epireapprovisionnementdemandedetail/:id',
                name: 'epireapprovisionnementdemandedetail',
                component: () => import('@views/page/epi/epireapprovisionnementdemandedetail/epireapprovisionnementdemandedetailPage.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'epi',
                    menuSelected: 'epireapprovisionnementdemandelist',
                },
            },
            {
                path: 'epi/epidotationcustomedit/:userId/:ruleId',
                name: 'epidotationcustomedit',
                component: () => import('@views/page/epi/epidotationcustomedit/epidotationcustomeditPage.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'epi',
                    menuSelected: 'userlist',
                },
            },
            {
                path: 'epi/epidotationreelleedit/:userId',
                name: 'epidotationreelleedit',
                component: () => import('@views/page/epi/epidotationreelleedit/epidotationreelleeditPage.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'epi',
                    menuSelected: 'userlist',
                },
            },
            {
                path: 'epi/epidotationreelleimport',
                name: 'epidotationreelleimport',
                component: () => import('@views/page/epi/epidotationreelleimport/epidotationreelleimportPage.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'epi',
                    menuSelected: 'userlist',
                },
            },
            {
                path: 'epi/epimouvementcreate',
                name: 'epimouvementcreate',
                component: () => import('@views/page/epi/epimouvementcreate/epimouvementcreatePage.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'epi',
                    menuSelected: 'epimouvementlist',
                },
            },
            {
                path: 'epi/epimouvementdetail/:id',
                name: 'epimouvementdetail',
                component: () => import('@views/page/epi/epimouvementdetail/epimouvementdetailPage.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'epi',
                    menuSelected: 'epimouvementlist',
                },
            },
            {
                path: 'epi/epimouvementlist',
                name: 'epimouvementlist',
                component: () => import('@views/page/epi/epimouvementlist/epimouvementlistPage.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'epi',
                },
            },
            {
                path: 'epi/epipredemandecreate',
                name: 'epipredemandecreate',
                component: () => import('@views/page/epi/epipredemandecreate/epipredemandecreatePage.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'epi',
                    menuSelected: 'epidemandelist',
                },
            },
            {
                path: 'epi/epipredemandedetail/:id',
                name: 'epipredemandedetail',
                component: () => import('@views/page/epi/epipredemandedetail/epipredemandedetailPage.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'epi',
                    menuSelected: 'epidemandelist',
                },
            },
            {
                path: 'epi/epipreretourcreate',
                name: 'epipreretourcreate',
                component: () => import('@views/page/epi/epipreretourcreate/epipreretourcreatePage.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'epi',
                    menuSelected: 'epiretourlist',
                },
            },
            {
                path: 'epi/epipreretourdetail/:id',
                name: 'epipreretourdetail',
                component: () => import('@views/page/epi/epipreretourdetail/epipreretourdetailPage.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'epi',
                    menuSelected: 'epiretourlist',
                },
            },
            {
                path: 'epi/epiretourcreate',
                name: 'epiretourcreate',
                component: () => import('@views/page/epi/epiretourcreate/epiretourcreatePage.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'epi',
                    menuSelected: 'epiretourlist',
                },
            },
            {
                path: 'epi/epiretourdetail/:id',
                name: 'epiretourdetail',
                component: () => import('@views/page/epi/epiretourdetail/epiretourdetailPage.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'epi',
                    menuSelected: 'epiretourlist',
                },
            },
            {
                path: 'epi/epiretourlist',
                name: 'epiretourlist',
                component: () => import('@views/page/epi/epiretourlist/epiretourlistPage.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'epi',
                },
            },
            {
                path: 'epi/epistockalerteupdate',
                name: 'epistockalerteupdate',
                component: () => import('@views/page/epi/epistockalerteupdate/epistockalerteupdatePage.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'epi',
                    menuSelected: 'epistocklist',
                },
            },
            {
                path: 'epi/epistocklist',
                name: 'epistocklist',
                component: () => import('@views/page/epi/epistocklist/epistocklistPage.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'epi',
                },
            },
            {
                path: 'epi/epistockupdate',
                name: 'epistockupdate',
                component: () => import('@views/page/epi/epistockupdate/epistockupdatePage.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'epi',
                    menuSelected: 'epistocklist',
                },
            },
            
            // EPI ADMIN
            
            {
                path: 'epiadmin/epiactivitelist',
                name: 'epiactivitelist',
                component: () => import('@views/page/epiadmin/epiactivitelist/epiactivitelistPage.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'epi',
                },
            },
            {
                path: 'epiadmin/epiarticlelist',
                name: 'epiarticlelist',
                component: () => import('@views/page/epiadmin/epiarticlelist/epiarticlelistPage.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'epi',
                },
            },
            {
                path: 'epiadmin/epifournisseurlist',
                name: 'epifournisseurlist',
                component: () => import('@views/page/epiadmin/epifournisseurlist/epifournisseurlistPage.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'epi',
                },
            },
            {
                path: 'epiadmin/epirubriquelist',
                name: 'epirubriquelist',
                component: () => import('@views/page/epiadmin/epirubriquelist/epirubriquelistPage.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'epi',
                },
            },
            {
                path: 'epiadmin/epitaillelist',
                name: 'epitaillelist',
                component: () => import('@views/page/epiadmin/epitaillelist/epitaillelistPage.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'epi',
                },
            },
            
            // PROFILE
            
            {
                path: 'profile',
                name: 'profile',
                component: () => import('@views/page/general/profile/profilePage.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'admin',
                },
            },
            
            // VH
            
            {
                path: 'vh/archive',
                name: 'archive',
                component: () => import('@views/page/vh/archive/archivePage.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'vh',
                },
            },
            {
                path: 'vh/forecastcreate',
                name: 'forecastcreate',
                component: () => import('@views/page/vh/forecastcreate/forecastcreatePage.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'vh',
                    menuSelected: 'forecastlist',
                },
            },
            {
                path: 'vh/forecastdetail/:id',
                name: 'forecastdetail',
                component: () => import('@views/page/vh/forecastdetail/forecastdetailPage.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'vh',
                    menuSelected: 'forecastlist',
                },
            },
            {
                path: 'vh/forecastlist',
                name: 'forecastlist',
                component: () => import('@views/page/vh/forecastlist/forecastlistPage.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'vh',
                },
            },
            {
                path: 'vh/forecastupdate/:id',
                name: 'forecastupdate',
                component: () => import('@views/page/vh/forecastupdate/forecastupdatePage.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'vh',
                    menuSelected: 'forecastlist',
                },
            },
            {
                path: 'vh/linkcreate',
                name: 'linkcreate',
                component: () => import('@views/page/vh/linkcreate/linkcreatePage.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'vh',
                    menuSelected: 'linklist',
                },
            },
            {
                path: 'vh/linkdetail/:id',
                name: 'linkdetail',
                component: () => import('@views/page/vh/linkdetail/linkdetailPage.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'vh',
                    menuSelected: 'linklist',
                },
            },
            {
                path: 'vh/linklist',
                name: 'linklist',
                component: () => import('@views/page/vh/linklist/linklistPage.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'vh',
                },
            },
            {
                path: 'vh/linkupdate/:id',
                name: 'linkupdate',
                component: () => import('@views/page/vh/linkupdate/linkupdatePage.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'vh',
                    menuSelected: 'linklist',
                },
            },
            
            // TEST
            
            {
                path: 'test/testdashboard',
                name: 'testdashboard',
                component: () => import('@views/page/test/testdashboard/testdashboardPage.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'admin',
                },
            },
            
            // NOT PAGE YET
            
            {
                path: 'documents',
                name: 'documents',
                component: () => import('@views/old/ged/GedView.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'ged',
                },
            },
            {
                path: 'search-documents',
                name: 'searchdocuments',
                component: () => import('@views/old/ged/GedSearchView.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'ged',
                },
            },
            {
                path: 'summary/daily/classic/list',
                name: 'classicdailysummarylist',
                component: () => import('@views/old/summary/ClassicDailySummaryList.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'vh',
                },
            },
            {
                path: 'summary/daily/modernized/list',
                name: 'modernizeddailysummarylist',
                component: () => import('@views/old/summary/ModernizedDailySummaryList.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'vh',
                },
            },
            {
                path: 'summary/weekly/list',
                name: 'weeklysummarylist',
                component: () => import('@views/old/summary/WeeklySummaryList.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'vh',
                },
            },
            {
                path: 'bilan/condtravail/list',
                name: 'bilancondtravaillist',
                component: () => import('@views/old/bilan/condtravail/BilanCondTravailList.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'vh',
                    menuSelected: 'bilancondtravailsynthese',
                },
            },
            {
                path: 'bilan/condtravail/synthese',
                name: 'bilancondtravailsynthese',
                component: () => import('@views/old/bilan/condtravail/BilanCondTravailSynthese.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'vh',
                },
            },
            {
                path: 'bilan/condtravail/create',
                name: 'bilancondtravailcreate',
                component: () => import('@views/old/bilan/condtravail/BilanCondTravailCreate.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'vh',
                    menuSelected: 'bilancondtravailsynthese',
                },
            },
            {
                path: 'bilan/condtravail/:id/update',
                name: 'bilancondtravailupdate',
                component: () => import('@views/old/bilan/condtravail/BilanCondTravailUpdate.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'vh',
                    menuSelected: 'bilancondtravailsynthese',
                },
            },
            {
                path: 'bilan/condtravail/:id/details',
                name: 'bilancondtravaildetails',
                component: () => import('@views/old/bilan/condtravail/BilanCondTravailDetails.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'vh',
                    menuSelected: 'bilancondtravailsynthese',
                },
            },
            {
                path: 'bilan/crise/list',
                name: 'bilancriselist',
                component: () => import('@views/old/bilan/crise/BilanCriseList.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'vh',
                    menuSelected: 'bilancrisesynthese',
                },
            },
            {
                path: 'bilan/crise/synthese',
                name: 'bilancrisesynthese',
                component: () => import('@views/old/bilan/crise/BilanCriseSynthese.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'vh',
                },
            },
            {
                path: 'bilan/crise/create',
                name: 'bilancrisecreate',
                component: () => import('@views/old/bilan/crise/BilanCriseCreate.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'vh',
                    menuSelected: 'bilancrisesynthese',
                },
            },
            {
                path: 'bilan/crise/period/create',
                name: 'bilancriseperiodcreate',
                component: () => import('@views/old/bilan/crise/BilanCrisePeriodCreate.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'vh',
                    menuSelected: 'bilancrisesynthese',
                },
            },
            {
                path: 'bilan/crise/:id/update',
                name: 'bilancriseupdate',
                component: () => import('@views/old/bilan/crise/BilanCriseUpdate.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'vh',
                    menuSelected: 'bilancrisesynthese',
                },
            },
            {
                path: 'bilan/crise/period/:id/update',
                name: 'bilancriseperiodupdate',
                component: () => import('@views/old/bilan/crise/BilanCrisePeriodUpdate.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'vh',
                    menuSelected: 'bilancrisesynthese',
                },
            },
            {
                path: 'bilan/crise/:id/details',
                name: 'bilancrisedetails',
                component: () => import('@views/old/bilan/crise/BilanCriseDetails.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'vh',
                    menuSelected: 'bilancrisesynthese',
                },
            },
            {
                path: 'bilan/crise/period/:id/details',
                name: 'bilancriseperioddetails',
                component: () => import('@views/old/bilan/crise/BilanCrisePeriodDetails.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'vh',
                    menuSelected: 'bilancrisesynthese',
                },
            },
            {
                path: 'bilan/formation/list',
                name: 'bilanformationlist',
                component: () => import('@views/old/bilan/formation/BilanFormationList.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'vh',
                    menuSelected: 'bilanformationsynthese',
                },
            },
            {
                path: 'bilan/formation/synthese',
                name: 'bilanformationsynthese',
                component: () => import('@views/old/bilan/formation/BilanFormationSynthese.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'vh',
                },
            },
            {
                path: 'bilan/formation/create',
                name: 'bilanformationcreate',
                component: () => import('@views/old/bilan/formation/BilanFormationCreate.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'vh',
                    menuSelected: 'bilanformationsynthese',
                },
            },
            {
                path: 'bilan/formation/:id/update',
                name: 'bilanformationupdate',
                component: () => import('@views/old/bilan/formation/BilanFormationUpdate.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'vh',
                    menuSelected: 'bilanformationsynthese',
                },
            },
            {
                path: 'bilan/formation/:id/details',
                name: 'bilanformationdetails',
                component: () => import('@views/old/bilan/formation/BilanFormationDetails.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'vh',
                    menuSelected: 'bilanformationsynthese',
                },
            },
            {
                path: 'bilan/materiel/list',
                name: 'bilanmateriellist',
                component: () => import('@views/old/bilan/materiel/BilanMaterielList.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'vh',
                    menuSelected: 'bilanmaterielsynthese',
                },
            },
            {
                path: 'bilan/materiel/synthese',
                name: 'bilanmaterielsynthese',
                component: () => import('@views/old/bilan/materiel/BilanMaterielSynthese.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'vh',
                },
            },
            {
                path: 'bilan/materiel/create',
                name: 'bilanmaterielcreate',
                component: () => import('@views/old/bilan/materiel/BilanMaterielCreate.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'vh',
                    menuSelected: 'bilanmaterielsynthese',
                },
            },
            {
                path: 'bilan/materiel/:id/update',
                name: 'bilanmaterielupdate',
                component: () => import('@views/old/bilan/materiel/BilanMaterielUpdate.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'vh',
                    menuSelected: 'bilanmaterielsynthese',
                },
            },
            {
                path: 'bilan/materiel/:id/details',
                name: 'bilanmaterieldetails',
                component: () => import('@views/old/bilan/materiel/BilanMaterielDetails.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'vh',
                    menuSelected: 'bilanmaterielsynthese',
                },
            },
            {
                path: 'bilan/circuit/list',
                name: 'bilancircuitlist',
                component: () => import('@views/old/bilan/circuit/BilanCircuitList.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'vh',
                    menuSelected: 'bilancircuitsynthese',
                },
            },
            {
                path: 'bilan/circuit/synthese',
                name: 'bilancircuitsynthese',
                component: () => import('@views/old/bilan/circuit/BilanCircuitSynthese.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'vh',
            
                },
            },
            {
                path: 'bilan/circuit/create',
                name: 'bilancircuitcreate',
                component: () => import('@views/old/bilan/circuit/BilanCircuitCreate.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'vh',
                    menuSelected: 'bilancircuitsynthese',
                },
            },
            {
                path: 'bilan/circuit/:id/update',
                name: 'bilancircuitupdate',
                component: () => import('@views/old/bilan/circuit/BilanCircuitUpdate.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'vh',
                    menuSelected: 'bilancircuitsynthese',
                },
            },
            {
                path: 'bilan/circuit/:id/:year/details',
                name: 'bilancircuitdetails',
                component: () => import('@views/old/bilan/circuit/BilanCircuitDetails.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'vh',
                    menuSelected: 'bilancircuitsynthese',
                },
            },
            {
                path: 'intervention/list',
                name: 'interventionlist',
                component: () => import('@views/old/intervention/InterventionList.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'intervention',
                },
            },
            {
                path: 'intervention/:id/details',
                name: 'interventiondetails',
                component: () => import('@views/old/intervention/InterventionDetails.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'intervention',
                    menuSelected: 'interventionlist',
                },
            },
            {
                path: 'intervention/:id/update',
                name: 'interventionupdate',
                component: () => import('@views/old/intervention/InterventionUpdate.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'intervention',
                    menuSelected: 'interventionlist',
                },
            },
            {
                path: 'intervention/create',
                name: 'interventioncreate',
                component: () => import('@views/old/intervention/InterventionCreate.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'intervention',
                    menuSelected: 'interventionlist',
                },
            },
            {
                path: 'admin/axeintervention',
                name: 'axeinterventionlist',
                component: () => import('@views/old/admin/axeintervention/AxeInterventionList.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'admin',
                },
            },
            {
                path: 'help',
                name: 'help',
                component: () => import('@views/old/help/help.vue'),
                meta: {
                    authRequired: true,
                    topbarMenu: 'help',
                },
            },
            {
                path: 'unauthorized',
                name: 'unauthorized',
                component: require('@views/core/_unauthorized.vue').default,
                // Allows props to be passed to the 404 page through route
                // params, such as `resource` to define what wasn't found.
                props: true,
            },
            {
                path: '/charte',
                name: 'charte',
                component: () => import('@views/old/charte/Charte.vue'),
                meta: {
                    authRequired: true
                }
            },
        ]
    },
    // {
    //     path: '/testmap',
    //     name: 'testmap',
    //     component: () => import('@views/old/TestMap.vue'),
    // },
    {
        path: '/404',
        name: '404',
        component: require('@views/core/_404.vue').default,
        // Allows props to be passed to the 404 page through route
        // params, such as `resource` to define what wasn't found.
        props: true,
    },
    {
        path: '/:pathMatch(.*)*',
        redirect: '404',
    },
]